import { render, staticRenderFns } from "./BiasVoip.vue?vue&type=template&id=2e9cdc39&scoped=true&"
import script from "./BiasVoip.vue?vue&type=script&lang=js&"
export * from "./BiasVoip.vue?vue&type=script&lang=js&"
import style0 from "./BiasVoip.vue?vue&type=style&index=0&id=2e9cdc39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9cdc39",
  null
  
)

export default component.exports